import React from "react";

const Column = ({ children, span = 12, style, className, ...restProps }) => {
  return <div style={{
    gridColumn: `auto / span ${span}`,
    ...style
  }} className={className} {...restProps}>{children}</div>;
};

export default Column;
